const DEFAULT_BRAND = {
  senderName: "Boaz Pest Control - Accounts Team",
  greeting: "Sir/Ma'am,",
  headerImage:
    "https://boaz-email-images.s3.ap-southeast-1.amazonaws.com/header_boaz_transparent1.png",
  footerImage:
    "https://boaz-email-images.s3.ap-southeast-1.amazonaws.com/footer_boaz_transparent1.png",
  contactEmail: "boazpestcontrol@gmail.com",
  unsubscribeEmail: "unsubscribe-boaz@maestrosystemsinc.com",
};

const escapeHtml = (value = "") =>
  String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const buildAttachmentLinksHtml = (attachmentLinks = {}) => {
  return Object.entries(attachmentLinks)
    .filter(([, url]) => Boolean(url))
    .map(([key, url]) => {
      const fileName = key
        .replace(/_url$/i, "")
        .replace(/_/g, " ")
        .toUpperCase();

      return `<li style="margin-bottom: 8px;">
        <a href="${escapeHtml(url)}" target="_blank" rel="noopener noreferrer">
          ${escapeHtml(fileName)}
        </a>
      </li>`;
    })
    .join("");
};

export function buildServiceReportEmail({
  formattedDate,
  attachmentLinks = {},
  brand = DEFAULT_BRAND,
}) {
  const attachmentLinksHtml = buildAttachmentLinksHtml(attachmentLinks);

  return `
    <html>
      <head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
        <title>Service Report</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            margin: 0;
            padding: 0;
            background-color: #f7f7f7;
          }
          .email-wrapper {
            width: 100%;
            background-color: #f7f7f7;
            padding: 24px 12px;
            box-sizing: border-box;
          }
          .email-container {
            width: 100%;
            max-width: 600px;
            margin: 0 auto;
            padding: 24px;
            background-color: #ffffff;
            border: 1px solid #dddddd;
            box-sizing: border-box;
          }
          .header,
          .footer {
            text-align: center;
          }
          .header img,
          .footer img {
            max-width: 100%;
            height: auto;
            display: block;
            margin: 0 auto;
          }
          .content {
            margin: 24px 0;
            color: #222222;
            line-height: 1.6;
            font-size: 14px;
          }
          .attachments {
            margin-top: 16px;
            padding-left: 20px;
          }
          .footer-text {
            margin-top: 16px;
            font-size: 12px;
            color: #666666;
            text-align: center;
          }
          .divider {
            border: none;
            border-top: 1px solid #dddddd;
            margin: 20px 0;
          }
        </style>
      </head>
      <body>
        <div class="email-wrapper">
          <div class="email-container">
            <div class="header">
              <img src="${escapeHtml(brand.headerImage)}" alt="Header" />
            </div>

            <div class="content">
              <p>${escapeHtml(brand.greeting)}</p>
              <p>Good day!</p>
              <p>
                We are pleased to send you our Accomplishment Report for the visit done on
                ${escapeHtml(formattedDate || "")}.
              </p>
              <p>
                We thank you and please let us know if you have any questions.
              </p>
              <p>Sincerely,</p>
              <p>${escapeHtml(brand.senderName)}</p>

              ${
                attachmentLinksHtml
                  ? `
                    <ul class="attachments">
                      ${attachmentLinksHtml}
                    </ul>
                  `
                  : ""
              }

              <hr class="divider" />
            </div>

            <div class="footer">
              <img src="${escapeHtml(brand.footerImage)}" alt="Footer" />
            </div>

            <div class="footer-text">
              <p>
                Contact us:
                <a href="mailto:${escapeHtml(brand.contactEmail)}">${escapeHtml(
    brand.contactEmail
  )}</a>
              </p>
              <p>
                If you no longer wish to receive these emails, you can
                <a href="mailto:${escapeHtml(brand.unsubscribeEmail)}">unsubscribe here</a>.
              </p>
            </div>
          </div>
        </div>
      </body>
    </html>
  `;
}